import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import SiteBreadcrumb from '../../components/layout/SiteBreadcrumb';
import BestFacilities from '../../components/shared/BestFacilities';
import { useDispatch } from 'react-redux';
import { LOADER_DURATION } from '../../../helpers/Constants';
import { showErrorMsg, showSuccessMsg, validateAnyFormField } from '../../../helpers/ValidationHelper';
import { MakeApiCallAsync } from '../../../helpers/ApiHelpers';
import Config from '../../../helpers/Config';
import rootAction from '../../../stateManagment/actions/rootAction';
import { Helmet } from 'react-helmet';
import { getLanguageCodeFromSession, GetLocalizationControlsJsonDataForScreen, replaceLoclizationLabel } from '../../../helpers/CommonHelper';
import GlobalEnums from '../../../helpers/GlobalEnums';
import './BecomeVendor.css';

const SELLER_TYPES = [
    {
        id: 3,
        name: 'Manufacturer',
        description: 'List products manufactured by your business.',
        icon: 'fas fa-industry'
    },
    {
        id: 5,
        name: 'Reseller',
        description: 'Supply products to businesses and customers.',
        icon: 'fas fa-truck-loading'
    },
    {
        id: 6,
        name: 'Hardware Shop',
        description: 'Sell products available in your local hardware shop.',
        icon: 'fas fa-store'
    }
];

const parseApiData = (data, fallback = []) => {
    if (data == null || data === '') return fallback;
    if (typeof data !== 'string') return data;

    try {
        return JSON.parse(data);
    } catch (error) {
        console.error('Invalid API response:', error);
        return fallback;
    }
};

const getApiErrorMessage = (response) => {
    const data = response?.response?.data ?? response?.data;
    return data?.errorMessage || data?.statusMessage || data?.message || response?.message;
};

const BecomeVendor = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [siteTitle] = useState(Config['SITE_TTILE']);
    const [FirstName, setFirstName] = useState('');
    const [LastName, setLastName] = useState('');
    const [EmailAddress, setEmailAddress] = useState('');
    const [Password, setPassword] = useState('');
    const [ConfirmPassword, setConfirmPassword] = useState('');
    const [MobileNo, setMobileNo] = useState('');
    const [AddressLineOne, setAddressLineOne] = useState('');
    const [StateProvinceId, setStateProvinceId] = useState('');
    const [CityId, setCityId] = useState('');
    const [PostalCode, setPostalCode] = useState('');
    const [CountryID, setCountryID] = useState('');
    const [CountriesList, setCountriesList] = useState([]);
    const [StatesProvincesList, setStatesProvincesList] = useState([]);
    const [CitiesList, setCitiesList] = useState([]);
    const [LocalizationLabelsArray, setLocalizationLabelsArray] = useState([]);
    const [UserTypeID, setUserTypeID] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);



    const HandleStateProvinceChagne = async (value) => {
        if (value != undefined) {
            setStateProvinceId(value);
            setCityId('');
            setCitiesList([]);

            //--load city data when state changed
            if (value && value !== '-999') {
                await LoadCitiesData(value);
            }
        }

    }

    const HandleCountryChange = async (value) => {
        if (value != undefined) {
            setCountryID(value);
            setStateProvinceId('');
            setCityId('');
            setStatesProvincesList([]);
            setCitiesList([]);

            //--load state province data
            if (value && value !== '-999') {
                await LoadStateProvinceData(value);
            }
        }

    }

    const LoadCitiesData = async (StateValue) => {
        const headersCity = {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        }


        const paramCity = {
            requestParameters: {
                StateProvinceId: StateValue ?? StateProvinceId,
                recordValueJson: "[]",
            },
        };

        //--Get cities list
        const responseCities = await MakeApiCallAsync(Config.END_POINT_NAMES['GET_CITIES_LIST'], null, paramCity, headersCity, "POST", true);
        if (responseCities?.data?.data != null) {
            setCitiesList(parseApiData(responseCities.data.data, []));

        }
    }

    const LoadStateProvinceData = async (CountryValue) => {
        const headersStateProvince = {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        }


        const paramStateProvince = {
            requestParameters: {
                CountryId: CountryValue ?? CountryID,
                recordValueJson: "[]",
            },
        };

        //--Get state province list
        const responseStatesProvince = await MakeApiCallAsync(Config.END_POINT_NAMES['GET_STATES_PROVINCES_LIST'], null, paramStateProvince, headersStateProvince, "POST", true);
        if (responseStatesProvince?.data?.data != null) {
            setStatesProvincesList(parseApiData(responseStatesProvince.data.data, []));

        }
    }
    const handleSellerSignupForm = async (event) => {
        event.preventDefault();

        if (isSubmitting) return false;

        try {

            if (!UserTypeID) {
                showErrorMsg('Please select a seller type.');
                return false;
            }

            const trimmedFirstName = FirstName.trim();
            const trimmedLastName = LastName.trim();
            const trimmedEmail = EmailAddress.trim().toLowerCase();
            const trimmedAddress = AddressLineOne.trim();
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
            const ownerNamePattern = /^[A-Za-z][A-Za-z .'-]*$/;
            const mobilePattern = /^[6-9]\d{9}$/;
            const pinCodePattern = /^\d{6}$/;

            if (trimmedFirstName.length < 2 || trimmedFirstName.length > 200) {
                showErrorMsg('Company name must be between 2 and 200 characters.');
                return false;
            }
            if (trimmedLastName.length < 2 || trimmedLastName.length > 150 || !ownerNamePattern.test(trimmedLastName)) {
                showErrorMsg('Owner name must be 2 to 150 characters and contain only letters, spaces, apostrophes, periods or hyphens.');
                return false;
            }
            if (trimmedEmail.length > 150 || !emailPattern.test(trimmedEmail)) {
                showErrorMsg('Please enter a valid email address.');
                return false;
            }
            if (!mobilePattern.test(MobileNo)) {
                showErrorMsg('Mobile number must contain 10 digits and start with 6, 7, 8 or 9.');
                return false;
            }
            if (!CountryID || CountryID === '-999') {
                showErrorMsg('Please select a country.');
                return false;
            }
            if (!StateProvinceId || StateProvinceId === '-999') {
                showErrorMsg('Please select a state/province.');
                return false;
            }
            if (!CityId || CityId === '-999') {
                showErrorMsg('Please select a city.');
                return false;
            }
            if (!pinCodePattern.test(PostalCode)) {
                showErrorMsg('PIN code must contain exactly 6 digits.');
                return false;
            }
            if (trimmedAddress.length < 5 || trimmedAddress.length > 600) {
                showErrorMsg('Business address must be between 5 and 600 characters.');
                return false;
            }
            if (Password !== ConfirmPassword) {
                showErrorMsg('Password and confirm password do not match.');
                return false;
            }


            let isValid = false;
            let validationArray = [];


            isValid = validateAnyFormField('First Name', FirstName, 'text', null, 200, true);
            if (isValid == false) {
                validationArray.push({
                    isValid: isValid
                });
            }


            isValid = validateAnyFormField('Last Name', LastName, 'text', null, 150, true);
            if (isValid == false) {
                validationArray.push({
                    isValid: isValid
                });
            }

            isValid = validateAnyFormField('Email', EmailAddress, 'email', null, 150, true);
            if (isValid == false) {
                validationArray.push({
                    isValid: isValid
                });
            }

            isValid = validateAnyFormField('Password', Password, 'password', null, 150, true);
            if (isValid == false) {
                validationArray.push({
                    isValid: isValid
                });
            }

            isValid = validateAnyFormField('Confirm Password', ConfirmPassword, 'password', null, 150, true);
            if (isValid == false) {
                validationArray.push({
                    isValid: isValid
                });
            }

            isValid = validateAnyFormField('Country', CountryID, 'text', null, 150, true);
            if (isValid == false) {
                validationArray.push({
                    isValid: isValid
                });
            }

            isValid = validateAnyFormField('Home address', AddressLineOne, 'text', null, 600, true);
            if (isValid == false) {
                validationArray.push({
                    isValid: isValid
                });
            }


            //--check if any field is not valid
            if (validationArray != null && validationArray.length > 0) {

                isValid = false;
                return false;
            } else {
                isValid = true;
            }

            if (isValid) {

                setIsSubmitting(true);

                const headers = {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                }

                const param = {
                    requestParameters: {
                        FirstName: trimmedFirstName,
                        LastName: trimmedLastName,
                        EmailAddress: trimmedEmail,
                        Password: Password,
                        MobileNo: MobileNo.trim(),
                        AddressLineOne: trimmedAddress,
                        CityId: Number(CityId),
                        StateProvinceId: Number(StateProvinceId),
                        PostalCode: PostalCode.trim(),
                        CountryID: Number(CountryID),
                        UserTypeID: Number(UserTypeID),
                    },
                };




                //--make api call for data operation
                const response = await MakeApiCallAsync(Config.END_POINT_NAMES['SIGNUP_USER'], null, param, headers, "POST", true);
                if (response?.response || !response?.data) {
                    showErrorMsg(getApiErrorMessage(response) || "No response received from the server. Please try again!");
                    return false;
                }

                if (response.data != null) {
                    if (response.data.statusCode && Number(response.data.statusCode) !== 200) {
                        showErrorMsg(getApiErrorMessage(response) || "The server could not create the seller account.");
                        return false;
                    }

                    const parsedUserData = parseApiData(response.data.data, []);

                    const userData = Array.isArray(parsedUserData)
                        ? parsedUserData
                        : parsedUserData && typeof parsedUserData === 'object'
                            ? [parsedUserData]
                            : [];
                    const responseMessage = userData[0]?.ResponseMsg?.trim();
                    const normalizedMessage = responseMessage?.toLowerCase().replace(/[!.]+$/, '').trim();

                    if (normalizedMessage === 'saved successfully') {
                        showSuccessMsg("Your request for seller created successfully!");

                        navigate('/' + getLanguageCodeFromSession() + '/');


                    } else if (normalizedMessage === 'email already exists') {
                        showErrorMsg("Email already exists!");
                        return false;
                    } else {
                        showErrorMsg(responseMessage || "The server returned an empty response. Please try again!");
                        return false;
                    }
                } else {
                    showErrorMsg("No response received from the server. Please try again!");
                    return false;
                }
            }



        } catch (err) {
            console.log(err);
            showErrorMsg("An error occured. Please try again!");

            return false;

        } finally {
            setIsSubmitting(false);
            //--stop loader
            setTimeout(() => {
                dispatch(rootAction.commonAction.setLoading(false));
            }, LOADER_DURATION);

        }
    }

    useEffect(() => {
        // declare the data fetching function
        const dataOperationInUseEffect = async () => {

            const headers = {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            }


            const paramCountry = {
                requestParameters: {

                    recordValueJson: "[]",
                },
            };


            //--Get countreis list
            const responseCountries = await MakeApiCallAsync(Config.END_POINT_NAMES['GET_COUNTRIES_LIST'], null, paramCountry, headers, "POST", true);
            if (responseCountries?.data?.data != null) {
                setCountriesList(parseApiData(responseCountries.data.data, []));

            }

            //-- Get website localization data
            let arryRespLocalization = await GetLocalizationControlsJsonDataForScreen(GlobalEnums.Entities["BecomeVendor"], null);
            if (arryRespLocalization != null && arryRespLocalization != undefined && arryRespLocalization.length > 0) {
                await setLocalizationLabelsArray(arryRespLocalization);
            }


        }

        //--start loader
        dispatch(rootAction.commonAction.setLoading(true));

        // call the function
        dataOperationInUseEffect().catch(console.error);

        //--stop loader
        setTimeout(() => {
            dispatch(rootAction.commonAction.setLoading(false));
        }, LOADER_DURATION);


    }, [])


    return (
        <>
            <Helmet>
                <title>{siteTitle} - Become Seller</title>
                <meta name="description" content={siteTitle + " - Become Seller"} />
                <meta name="keywords" content="Become Seller"></meta>
            </Helmet>
            <SiteBreadcrumb title="Become Seller" />

            <section className="signup-area ptb-60 become-seller-page">
                <div className="container">
                    <div className="signup-content become-seller-content">
                        <div className="section-title">
                            <h2><span className="dot"></span>
                                <span id="lbl_becomeseller_crtaccount">
                                    {LocalizationLabelsArray.length > 0 ?
                                        replaceLoclizationLabel(LocalizationLabelsArray, "Create Seller Account", "lbl_becomeseller_crtaccount")
                                        :
                                        "Create Seller Account"
                                    }
                                </span>
                            </h2>
                        </div>

                        <form className="signup-form become-seller-form" onSubmit={handleSellerSignupForm}>

                            <div className="seller-type-section">
                                <div className="seller-type-heading">
                                    <span className="seller-type-eyebrow">Start selling with Asuremart</span>
                                    <h3>What type of seller are you?</h3>
                                    <p>Select the option that best describes your business.</p>
                                </div>

                                <div className="seller-type-grid" role="radiogroup" aria-label="Seller type">
                                    {SELLER_TYPES.map((sellerType) => {
                                        const selected = Number(UserTypeID) === sellerType.id;
                                        return (
                                            <label
                                                className={`seller-type-card${selected ? ' selected' : ''}`}
                                                key={sellerType.id}
                                            >
                                                <input
                                                    type="radio"
                                                    name="UserTypeID"
                                                    value={sellerType.id}
                                                    checked={selected}
                                                    onChange={(event) => setUserTypeID(event.target.value)}
                                                    required
                                                />
                                                <span className="seller-type-icon" aria-hidden="true">
                                                    <i className={sellerType.icon}></i>
                                                </span>
                                                <span className="seller-type-copy">
                                                    <strong>{sellerType.name}</strong>
                                                    <small>{sellerType.description}</small>
                                                </span>
                                                <span className="seller-type-check" aria-hidden="true">
                                                    <i className="fas fa-check"></i>
                                                </span>
                                            </label>
                                        );
                                    })}
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-lg-6 col-md-6'>
                                    <div className="form-group">
                                        <label>
                                            {LocalizationLabelsArray.length > 0 ?
                                                replaceLoclizationLabel(LocalizationLabelsArray, "First Name", "lbl_becomeseller_fname")
                                                :
                                                "Company name"
                                            }
                                            <span className="required-field">*</span></label>
                                        <input type="text" className="form-control" placeholder="Enter Company name" id="FirstName" name="FirstName"
                                            required={true}
                                            minLength={2}
                                            maxLength={200}
                                            value={FirstName}
                                            onChange={(e) => setFirstName(e.target.value)}
                                        />
                                    </div>
                                </div>

                                <div className='col-lg-6 col-md-6'>
                                    <div className="form-group">
                                        <label>
                                            {LocalizationLabelsArray.length > 0 ?
                                                replaceLoclizationLabel(LocalizationLabelsArray, "Last Name", "lbl_becomeseller_lname")
                                                :
                                                "Owner Name"
                                            }
                                            <span className="required-field">*</span></label>
                                        <input type="text" className="form-control" placeholder="Enter Owner Name" id="LastName" name="LastName"
                                            required={true}
                                            minLength={2}
                                            maxLength={150}
                                            pattern="[A-Za-z][A-Za-z .'-]*"
                                            title="Use letters, spaces, apostrophes, periods or hyphens only"
                                            value={LastName}
                                            onChange={(e) => setLastName(e.target.value)}
                                        />
                                    </div>
                                </div>

                                <div className='col-lg-6 col-md-6'>
                                    <div className="form-group">
                                        <label>
                                            {LocalizationLabelsArray.length > 0 ?
                                                replaceLoclizationLabel(LocalizationLabelsArray, "Email", "lbl_becomeseller_email")
                                                :
                                                "Email"
                                            }
                                            <span className="required-field">*</span></label>
                                        <input type="email" className="form-control" placeholder="Enter email" id="EmailAddress" name="EmailAddress"
                                            required={true}
                                            maxLength={150}
                                            autoComplete="email"
                                            value={EmailAddress}
                                            onChange={(e) => setEmailAddress(e.target.value)}
                                        />
                                    </div>
                                </div>

                                <div className='col-lg-6 col-md-6'>
                                    <div className="form-group">
                                        <label>
                                            {LocalizationLabelsArray.length > 0 ?
                                                replaceLoclizationLabel(LocalizationLabelsArray, "Mobile No", "lbl_becomeseller_contact")
                                                :
                                                "Mobile No"
                                            }
                                            <span className="required-field">*</span>
                                        </label>
                                        <input type="tel" className="form-control" placeholder="Enter 10-digit mobile no" id="MobileNo" name="MobileNo"
                                            required={true}
                                            inputMode="numeric"
                                            autoComplete="tel"
                                            pattern="[6-9][0-9]{9}"
                                            minLength={10}
                                            maxLength={10}
                                            title="Enter a 10-digit mobile number starting with 6, 7, 8 or 9"
                                            value={MobileNo}
                                            onChange={(e) => setMobileNo(e.target.value.replace(/\D/g, '').slice(0, 10))}
                                        />
                                    </div>
                                </div>

                                <div className='col-lg-6 col-md-6'>
                                    <div className="form-group">
                                        <label>
                                            {LocalizationLabelsArray.length > 0 ?
                                                replaceLoclizationLabel(LocalizationLabelsArray, "Country", "lbl_becomeseller_country")
                                                :
                                                "Country"
                                            }
                                            <span className="required-field">*</span></label>
                                        <div className="select-box">
                                            <select
                                                className="form-control"
                                                name="CountryID"
                                                required={true}
                                                value={CountryID}
                                                onChange={(e) => HandleCountryChange(e.target.value)}
                                            >
                                                <option value="" disabled>Select Country</option>
                                                {
                                                    CountriesList?.map((item) =>

                                                        <option key={item.CountryID} value={item.CountryID}>{item.CountryName}</option>

                                                    )}


                                            </select>
                                        </div>
                                    </div>
                                </div>


                                <div className='col-lg-6 col-md-6'>
                                    <div className="form-group">
                                        <label>
                                            {LocalizationLabelsArray.length > 0 ?
                                                replaceLoclizationLabel(LocalizationLabelsArray, "State/Province", "lbl_becomeseller_province")
                                                :
                                                "State/Province"
                                            }
                                            <span className="required-field">*</span>
                                        </label>
                                        <div className="select-box">
                                            <select
                                                className="form-control"
                                                name="StateProvinceId"
                                                required={true}
                                                value={StateProvinceId}
                                                onChange={(e) => HandleStateProvinceChagne(e.target.value)}
                                            >
                                                <option value="" disabled>Select State</option>
                                                {
                                                    StatesProvincesList?.map((item) =>

                                                        <option key={item.StateProvinceID} value={item.StateProvinceID}>{item.StateName}</option>

                                                    )}


                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <div className='col-lg-6 col-md-6'>
                                    <div className="form-group">
                                        <label>
                                            {LocalizationLabelsArray.length > 0 ?
                                                replaceLoclizationLabel(LocalizationLabelsArray, "City", "lbl_becomeseller_city")
                                                :
                                                "City"
                                            }
                                            <span className="required-field">*</span>
                                        </label>
                                        <div className="select-box">
                                            <select
                                                className="form-control"
                                                name="CityId"
                                                required={true}
                                                value={CityId}
                                                onChange={(e) => setCityId(e.target.value)}
                                            >
                                                <option value="" disabled>Select City</option>
                                                {
                                                    CitiesList?.map((item) =>

                                                        <option key={item.CityID} value={item.CityID}>{item.CityName}</option>

                                                    )}


                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <div className='col-lg-6 col-md-6'>
                                    <div className="form-group">
                                        <label>
                                            {LocalizationLabelsArray.length > 0 ?
                                                replaceLoclizationLabel(LocalizationLabelsArray, "Postal Code", "lbl_becomeseller_pcode")
                                                :
                                                "Postal Code"
                                            }
                                            <span className="required-field">*</span>
                                        </label>
                                        <input type="text" className="form-control" placeholder="Enter 6-digit PIN code" id="PostalCode" name="PostalCode"
                                            required={true}
                                            inputMode="numeric"
                                            autoComplete="postal-code"
                                            pattern="[0-9]{6}"
                                            minLength={6}
                                            maxLength={6}
                                            title="Enter exactly 6 digits"
                                            value={PostalCode}
                                            onChange={(e) => setPostalCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
                                        />
                                    </div>
                                </div>

                                <div className='col-lg-6 col-md-6'>
                                    <div className="form-group">
                                        <label>
                                            {LocalizationLabelsArray.length > 0 ?
                                                replaceLoclizationLabel(LocalizationLabelsArray, "Password", "lbl_becomeseller_password")
                                                :
                                                "Password"
                                            }
                                            <span className="required-field">*</span>
                                        </label>
                                        <input type="password" className="form-control" placeholder="Enter your password" id="Password" name="Password"
                                            required={true}
                                            autoComplete="new-password"
                                            value={Password}
                                            onChange={(e) => setPassword(e.target.value)}
                                        />
                                    </div>
                                </div>

                                <div className='col-lg-6 col-md-6'>
                                    <div className="form-group">
                                        <label>
                                            {LocalizationLabelsArray.length > 0 ?
                                                replaceLoclizationLabel(LocalizationLabelsArray, "Confirm Password", "lbl_becomeseller_confpassword")
                                                :
                                                "Confirm Password"
                                            }
                                            <span className="required-field">*</span>
                                        </label>
                                        <input type="password" className="form-control" placeholder="Confirm Password" id="ConfirmPassword" name="ConfirmPassword"
                                            required={true}
                                            autoComplete="new-password"
                                            value={ConfirmPassword}
                                            onChange={(e) => setConfirmPassword(e.target.value)}
                                        />
                                    </div>
                                </div>



                                <div className='col-lg-12 col-md-12'>
                                    <div className="form-group">
                                        <label>
                                            {LocalizationLabelsArray.length > 0 ?
                                                replaceLoclizationLabel(LocalizationLabelsArray, "Home Address", "lbl_becomeseller_homeadr")
                                                :
                                                "Home/Business Address"
                                            }
                                            <span className="required-field">*</span></label>
                                        <input type="text" className="form-control" placeholder="Enter home/Business address" id="AddressLineOne" name="AddressLineOne"
                                            required={true}
                                            minLength={5}
                                            maxLength={600}
                                            autoComplete="street-address"
                                            value={AddressLineOne}
                                            onChange={(e) => setAddressLineOne(e.target.value)}
                                        />
                                    </div>
                                </div>

                            </div>



                            <div className="seller-form-actions">
                                <button type="submit" className="btn btn-primary" id="lbl_becomeseller_submitbnt" disabled={isSubmitting}>
                                    {isSubmitting ? "Creating Account..." : LocalizationLabelsArray.length > 0 ?
                                        replaceLoclizationLabel(LocalizationLabelsArray, "Signup", "lbl_becomeseller_submitbnt")
                                        :
                                        "Create Seller Account"
                                    }
                                </button>

                                <Link to={`/${getLanguageCodeFromSession()}/login`} className="return-store" id="lbl_becomeseller_loginacnt">
                                    {LocalizationLabelsArray.length > 0 ?
                                        replaceLoclizationLabel(LocalizationLabelsArray, "or Login to your account", "lbl_becomeseller_loginacnt")
                                        :
                                        "Already have an account? Login"
                                    }
                                </Link>
                            </div>
                        </form>
                    </div>
                </div>
            </section>

            <BestFacilities />


        </>
    );
}

export default BecomeVendor;
